import React from 'react';
import { useAppDispatch, useAppSelector} from "../DAL/store";
import {getPresetsPage} from "../../common/DAL/data-service";
import {rootActions} from "../../../management-tools/banner-manager/DAL/store";
import { updatePageTitle } from '../../presets-by-tag/components/pagination';


export interface IPaginationProps {
    setIsLoading: any;
}
const Pagination = (props : IPaginationProps) => {

    const dispatch = useAppDispatch();

    const PublicCreatorProfileData = useAppSelector((store) => store.PublicCreatorProfileData);

    const applyPagination = async (previous : boolean) =>{
        let pageIndex = previous ? PublicCreatorProfileData.profile.pageNumber - 1 : PublicCreatorProfileData.profile.pageNumber + 1;
        //if pageIndex is valid index get data
        if(pageIndex > 0 && pageIndex <= PublicCreatorProfileData.profile.numberOfPages){
            props.setIsLoading(true);
            const response = await getPresetsPage(PublicCreatorProfileData.profile.handle,pageIndex);
            props.setIsLoading(false);

            if(!response || response.statusCode !== 200 || !response.data.isValid || !response.data.relatedData) return;

            window.history.replaceState({}, '', document.location.pathname + "?page=" + response.data.relatedData.profile.pageNumber);

            dispatch(
                rootActions.main({
                    PublicCreatorProfileData : response.data.relatedData
                })
            );

            updatePageTitle(pageIndex);

            // jump to top
            window.scrollTo(0, 0);
        }
    }
    //PublicCreatorProfileData.profile.pageNumber
    return (
        <div className="flex items-center w-full lg:w-3/4 xl:w-2/3 mt-6">
            <button
                type="button"
                className={`${PublicCreatorProfileData.profile.pageNumber === 1 ? "cursor-not-allowed" : "cursor-pointer"} mr-1`}
                onClick={async evt => {
                    await applyPagination(true);
                }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30"><title>Previous Page</title><g fill="none" fillRule="evenodd"><rect width="29" height="29" x=".5" y=".5" fill="#D8D8D8" fillRule="nonzero" stroke="#979797" opacity=".123" rx="14.5"/><path d="M17.295 9.705c.39.39.39 1.02 0 1.41L13.42 15l3.876 3.884a.999.999 0 0 1-1.411 1.411L10.59 15l5.295-5.295a.996.996 0 0 1 1.41 0z" fill="#252525"/></g></svg>
            </button>

            <button
                type="button"
                className={`${PublicCreatorProfileData.profile.pageNumber === PublicCreatorProfileData.profile.numberOfPages ? "cursor-not-allowed" : "cursor-pointer"} ml-1`}
                onClick={async evt  => {
                    await applyPagination(false);
                }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30"><title>Next Page</title><g fill="none" fillRule="evenodd"><rect width="29" height="29" x=".5" y=".5" fill="#D8D8D8" fillRule="nonzero" stroke="#979797" opacity=".123" rx="14.5"/><path d="M12.705 9.705a.996.996 0 0 0 0 1.41L16.58 15l-3.876 3.884a.999.999 0 0 0 1.411 1.411L19.41 15l-5.295-5.295a.996.996 0 0 0-1.41 0z" fill="#252525"/></g></svg>
            </button>

            <span className="mx-4">
                Page { PublicCreatorProfileData.profile.pageNumber} of { PublicCreatorProfileData.profile.numberOfPages }
            </span>

        </div>


    )
};

export default Pagination;